import { z } from 'zod';
import { idSchema } from './common.js';
const groupPrivacySchema = z.enum(['public', 'closed', 'secret']);
const groupSlugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/, 'Slug must be 3–40 chars, a–z, 0–9, hyphen');
export const createGroupBodySchema = z.object({
    slug: groupSlugSchema,
    name: z.string().trim().min(1).max(80),
    description: z.string().trim().max(2000).optional(),
    privacy: groupPrivacySchema.default('public'),
    region: z.string().trim().max(40).optional(),
    fleetId: idSchema.optional(),
});
export const updateGroupBodySchema = z.object({
    name: z.string().trim().min(1).max(80).optional(),
    description: z.string().trim().max(2000).nullable().optional(),
    privacy: groupPrivacySchema.optional(),
    region: z.string().trim().max(40).nullable().optional(),
});
export const groupSlugParamSchema = z.object({
    slug: groupSlugSchema,
});
export const groupIdParamSchema = z.object({
    groupId: idSchema,
});
export const updateGroupMemberBodySchema = z.object({
    role: z.enum(['admin', 'moderator', 'member']),
});
export const banGroupMemberBodySchema = z.object({
    reason: z.string().trim().min(3).max(240),
});
export const listGroupsQuerySchema = z.object({
    region: z.string().trim().max(40).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
//# sourceMappingURL=group.js.map